import {
  KeyboardArrowDownOutlined,
  KeyboardArrowUpOutlined,
} from "@mui/icons-material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useState } from "react";

export default function TripsHistory() {

  const token = sessionStorage.getItem("token");
  const [expandedOrderId, setExpandedOrderId] = useState(null);
  const [ordersByDate, setOrdersByDate] = useState({});
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [pagination, setPagination] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 10;
    const [mapModalOpen, setMapModalOpen] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState(null);

  const formatDate = (dateString) => {
    if (!dateString) return "تاريخ غير محدد";
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = date.toLocaleString("en-GB", { month: "long" });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  const fetchOrders = async (page = 1) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page);
      params.append("per_page", perPage);
      if (fromDate) params.append("from", fromDate);
      if (toDate) params.append("to", toDate);

      const response = await fetch(
        `https://estbn.com/EstbnNew/public/api/stuff/trips/history?${params.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        },
      );

      const result = await response.json();
      setOrdersByDate(result.data.data || {});
      setPagination(result.data.pagination || null);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  useEffect(() => {
    fetchOrders(currentPage);
  }, [currentPage]);

  const handleSearch = () => {
    setCurrentPage(1);
    fetchOrders(1);
  };

  const handleReset = () => {
    setFromDate("");
    setToDate("");
    setCurrentPage(1);
    setTimeout(() => fetchOrders(1), 0);
  };

  const handlePageChange = (page) => {
    if (page < 1 || (pagination && page > pagination.last_page)) return;
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const getPageNumbers = () => {
    if (!pagination) return [];
    const total = pagination.last_page;
    const current = pagination.current_page;
    const pages = [];

    if (total <= 7) {
      for (let i = 1; i <= total; i++) pages.push(i);
    } else {
      pages.push(1);
      if (current > 3) pages.push("...");
      for (
        let i = Math.max(2, current - 1);
        i <= Math.min(total - 1, current + 1);
        i++
      ) {
        pages.push(i);
      }
      if (current < total - 2) pages.push("...");
      pages.push(total);
    }
    return pages;
  };

  const isEmpty = Object.keys(ordersByDate).length === 0;

  return (
    <div className="w-100 py-4 px-3 px-md-4" dir="rtl">
      {/* ── Date Range Picker ── */}
      <div
        className="mb-4 p-3 p-md-4 rounded-4 shadow-sm"
        style={{
          background: "linear-gradient(135deg, #f8f9ff 0%, #eef1ff 100%)",
          border: "1px solid #e0e4ff",
        }}
      >
        <h6 className="fw-bold mb-3" style={{ color: "#000000" }}>
          🗓 تصفية حسب التاريخ
        </h6>
        <div className="row g-3 align-items-end">
          <div className="col-12 col-sm-4">
            <label className="form-label small fw-semibold text-muted mb-1">
              من تاريخ
            </label>
            <input
              type="date"
              className="form-control rounded-3 border-0 shadow-sm"
              style={{ background: "#fff", fontSize: "0.9rem" }}
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>
          <div className="col-12 col-sm-4">
            <label className="form-label small fw-semibold text-muted mb-1">
              إلى تاريخ
            </label>
            <input
              type="date"
              className="form-control rounded-3 border-0 shadow-sm"
              style={{ background: "#fff", fontSize: "0.9rem" }}
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
          <div className="col-12 col-sm-4 d-flex gap-2 text-end">
            <button
              className="btn fw-semibold flex-grow-1 rounded-3 text-white btn-dark"
              style={
                {
                  // background: "linear-gradient(135deg, #3d4fd7, #6c63ff)",
                  // fontSize: "0.9rem",
                }
              }
              onClick={handleSearch}
            >
              بحث
            </button>
            {(fromDate || toDate) && (
              <button
                className="btn btn-outline-secondary rounded-3 fw-semibold"
                style={{ fontSize: "0.9rem" }}
                onClick={handleReset}
              >
                مسح
              </button>
            )}
          </div>
        </div>
        {/* Pagination info summary */}
        {pagination && (
          <div className="mt-3 d-flex flex-wrap gap-3">
            <span
              className="badge rounded-pill px-3 py-2"
              style={{
                background: "#e8eaff",
                color: "#050505",
                fontSize: "0.8rem",
              }}
            >
              إجمالي الأيام: {pagination.total_dates}
            </span>
            <span
              className="badge rounded-pill px-3 py-2"
              style={{
                background: "#e8eaff",
                color: "#000000",
                fontSize: "0.8rem",
              }}
            >
              الصفحة {pagination.current_page} من {pagination.last_page}
            </span>
          </div>
        )}
      </div>
      {/* ── Orders List ── */}
      <div className="row g-3">
        <div className="col-12">
          {isEmpty ? (
            <div className="text-center py-5 text-muted">
              <div style={{ fontSize: "2.5rem" }}>📭</div>
              <p className="mt-2">لا توجد رحلات في هذه الفترة</p>
            </div>
          ) : (
            Object.entries(ordersByDate).map(([date, orders]) => (
              <div key={date} className="mb-4">
                <div dir="ltr" className="text-end">
                  <h6 className="fw-bold text-muted mb-3">
                    {formatDate(date)}
                  </h6>
                </div>
                {orders.map((order) => (
                  <div
                    key={order.id}
                    className="mb-3 shadow-sm border-0 rounded-4 overflow-hidden bg-white"
                  >
                    <div
                      className="d-flex justify-content-between align-items-center p-3 bg-light cursor-pointer"
                      onClick={() =>
                        setExpandedOrderId(
                          expandedOrderId === order.id ? null : order.id,
                        )
                      }
                    >
                      <div className="d-flex align-items-center gap-3">
                        <span className="text-muted small d-none d-sm-inline">
                          طلب رقم
                        </span>
                        <span className="fw-bold fs-6">
                          #{order.door_step_order_id || order.id}
                        </span>
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                          style={{
                            width: "28px",
                            maxWidth: "28px",
                            height: "28px",
                            maxHeight: "28px",
                          }}
                        >
                          <img
                            src={order?.order_status_image_url}
                            alt=""
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <span className="fw-bold" dir="ltr">
                          {formatDate(order?.started_at)}
                        </span>
                        {expandedOrderId === order.id ? (
                          <KeyboardArrowUpOutlined />
                        ) : (
                          <KeyboardArrowDownOutlined />
                        )}
                      </div>
                    </div>
                    {expandedOrderId === order.id && (
                      <div className="p-3 p-md-4 bg-white">
                        <div className="p-3 border rounded-4">
                          <div className="mb-3 text-end pb-2 border-bottom">
                            <span className="text-muted small">
                              الخدمة المطلوبة:{" "}
                            </span>
                            <span className="fw-bold text-dark">
                              {order.service_snapshot?.name || "خدمة صيانة"}
                            </span>
                          </div>
                          <div className="row g-3">
                            <div className="col-4 text-end">
                              <p className="text-muted small mb-1">
                                حالة الرحلة
                              </p>
                              <p
                                className="fw-bold mb-0"
                                style={{ fontSize: "0.85rem", color: "black" }}
                              >
                                {order.status}
                              </p>
                            </div>
                            <div className="col-4 text-end border-end border-start">
                              <p className="text-muted small mb-1">الوقت</p>
                              <p
                                className="fw-bold mb-0"
                                style={{ fontSize: "0.85rem" }}
                              >
                                {(() => {
                                  const date = new Date(
                                    order?.ended_at || order.started_at,
                                  );
                                  const datePart = date.toLocaleDateString(
                                    "en-US",
                                    {
                                      month: "long",
                                      day: "numeric",
                                      year: "numeric",
                                    },
                                  );
                                  const timePart = date.toLocaleTimeString(
                                    "en-US",
                                    {
                                      hour: "numeric",
                                      minute: "2-digit",
                                      hour12: true,
                                    },
                                  );
                                  return `${datePart} – ${timePart}`;
                                })()}
                              </p>
                            </div>
                            <div className="col-4">
                              <p className="text-muted small mb-1">العنوان</p>
                              <p
                                className="fw-bold mb-0 text-muted"
                                style={{
                                  fontSize: "0.8rem",
                                  lineHeight: "1.4",
                                }}
                              >
                                {order.address || "غير متوفر"}
                              </p>
                              {order.latitude && order.longitude && (
                                <button
                                  type="button"
                                  onClick={() => {
                                    setSelectedLocation({
                                      latitude: order.latitude,
                                      longitude: order.longitude,
                                    });
                                    setMapModalOpen(true);
                                  }}
                                  className="small d-inline-flex align-items-center gap-1 border-0 bg-transparent p-0"
                                  style={{
                                    color: "#3EADA3",
                                    fontWeight: 600,
                                    textDecoration: "none",
                                    marginTop: "4px",
                                    cursor: "pointer",
                                  }}
                                >
                                  View on Map
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ))
          )}
        </div>
      </div>

      {/* ── Pagination ── */}
      {pagination && pagination.last_page > 1 && (
        <div className="d-flex justify-content-center mt-4 mb-2">
          <div
            className="d-flex align-items-center gap-1 p-2 rounded-4 shadow-sm"
            style={{ background: "#fff", border: "1px solid #e8eaff" }}
          >
            {/* Prev */}
            <button
              onClick={() => handlePageChange(pagination.current_page - 1)}
              disabled={pagination.current_page === 1}
              className="btn btn-sm rounded-3 d-flex align-items-center justify-content-center"
              style={{
                width: "36px",
                height: "36px",
                background:
                  pagination.current_page === 1 ? "#f5f5f5" : "#eef1ff",
                border: "none",
                color: pagination.current_page === 1 ? "#bbb" : "#000000",
                fontWeight: "bold",
                fontSize: "1.2rem",
              }}
            >
              ›
            </button>
            {/* Page Numbers */}
            {getPageNumbers().map((page, idx) =>
              page === "..." ? (
                <span
                  key={`ellipsis-${idx}`}
                  className="px-1 text-muted"
                  style={{ fontSize: "0.85rem" }}
                >
                  …
                </span>
              ) : (
                <button
                  key={page}
                  onClick={() => handlePageChange(page)}
                  className="btn btn-sm rounded-3 d-flex align-items-center justify-content-center fw-semibold"
                  style={{
                    width: "36px",
                    height: "36px",
                    border: "none",
                    fontSize: "0.85rem",
                    transition: "all 0.2s",
                    background:
                      pagination.current_page === page
                        ? "linear-gradient(135deg, #555, #000000)"
                        : "transparent",
                    color: pagination.current_page === page ? "#fff" : "#555",
                    boxShadow:
                      pagination.current_page === page
                        ? "0 2px 8px rgba(7, 7, 7, 0.35)"
                        : "none",
                  }}
                >
                  {page}
                </button>
              ),
            )}
            {/* Next */}
            <button
              onClick={() => handlePageChange(pagination.current_page + 1)}
              disabled={pagination.current_page === pagination.last_page}
              className="btn btn-sm rounded-3 d-flex align-items-center justify-content-center"
              style={{
                width: "36px",
                height: "36px",
                background:
                  pagination.current_page === pagination.last_page
                    ? "#f5f5f5"
                    : "#eef1ff",
                border: "none",
                color:
                  pagination.current_page === pagination.last_page
                    ? "#bbb"
                    : "#000000",
                fontWeight: "bold",
                fontSize: "1.2rem",
              }}
            >
              ‹
            </button>
          </div>
        </div>
      )}
         <Dialog
              open={mapModalOpen}
              onClose={() => setMapModalOpen(false)}
              maxWidth="md"
              fullWidth
            >
              <DialogContent style={{ padding: 0, position: "relative" }}>
                <IconButton
                  onClick={() => setMapModalOpen(false)}
                  style={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    zIndex: 1,
                    background: "#fff",
                  }}
                  size="small"
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
                {selectedLocation && (
                  <iframe
                    title="order-location-map"
                    src={`https://maps.google.com/maps?q=${selectedLocation.latitude},${selectedLocation.longitude}&z=16&output=embed`}
                    width="100%"
                    height="450"
                    style={{ border: 0, display: "block" }}
                    loading="lazy"
                    allowFullScreen
                  />
                )}
              </DialogContent>
            </Dialog>
    </div>
  );
}
